import { Component } from 'react';
import { connect } from 'react-redux';
import { refreshView as refreshViewAction } from 'react-admin';

class MyRefresh extends Component {
  componentDidMount() {
    const { refreshInterval } = this.props;
    // const { refreshView } = this.props;
    if (refreshInterval) {
      this.interval = setInterval(() => {
        //refreshView();
      }, refreshInterval);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return null;
  }
}

const RefreshButton = connect(
  null,
  { refreshView: refreshViewAction }
)(MyRefresh);

export default RefreshButton;



// WEBPACK FOOTER //
// ./src/components/RefreshListActions.js